<template>
    <b-form>
        <b-row class="m-2">
            <b-col v-if="loaded === false">
                <template>
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
            </b-col>
            <b-col v-else>
                <b-row>
                    <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>          
                    <ECMPartitionModal v-model="showECMPartitionModal" :existingNames="paramSets" ref="ecmPartitionModal" /> 
                    <ECMCreatePartitionParameters v-model="showECMPartitionFoldersModal" :existingNames="selectedFolders" ref="ecmPartitionFoldersModal" /> 
                    <ECMConfirmDialog ref="confirmationDlg" v-model="confirmationDlg"/>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="row no-gutters">
            <span class="OTtableTitleBreadCrumb">
                <span class="OTtableTitleBreadCrumbTextJob"></span>
            </span>
        </b-row>
        <b-row class="row no-gutters">
            <b-col class="col-auto col">
                <b-nav>
                    <b-nav-item v-for="action in globalActions" @click.prevent="onGlobalAction(action)" :key="action.name">
                        <otif-icon :icon="action.name" :label="action.label" :title="action.label" key="action.name"/>
                    </b-nav-item>
                </b-nav>
            </b-col>
        </b-row>
        <b-row>
            <b-col v-if="paramSets.length === 0">
                <span class="OTtableJobType"><p> {{ecmResourceStrings.txtPartitionsNotDefined}}</p>
                    <otif-icon icon="information"/>
                </span >
            </b-col>
            <b-col v-else>
                <ecmconnection-select
                    v-model="$v.selectedSet"
                    v-bind:label="ecmResourceStrings.lblECMPartitions"
                    :parameters="paramSets"
                    :selectedSet="selectedSet"
                    ref="params_selector"
                    :description="ecmResourceStrings.tipECMPartitions"
                    v-bind:invalidMessage="ecmResourceStrings.msgECMPartitionRequired"
                    @reselected="reselected"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <template v-if="loaded === false">
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
                <template v-else-if="loaded === true && paramSets.length === 0">
                   
                </template>
                <SettingsTable v-else
                    :rows="selectedParameters"
                    :columns="columns"
                    :customOptions="customOptions"
                    :formcolumn="'2'"
                    @save="save">
                    <template slot="table-header">
                        
                    </template>
                </SettingsTable>
            </b-col>
        </b-row>
        
        <template v-if="loaded === true && paramSets.length > 0">
            <b-row class="row no-gutters OT-content-header">
                <b-col class="col-auto col"></b-col>
            </b-row>
            <span class="OTtableTitleBreadCrumb">
                <span class="OTtableTitleBreadCrumbTextJob">{{ecmResourceStrings.lblPartitionFolders}}</span>
            </span>
            <b-row class="row no-gutters ">
                <b-col class="col-auto col">
                    <b-nav>
                        <b-nav-item v-for="action in partitionActions" @click.prevent="onGlobalAction(action)" :key="action.name">
                            <otif-icon :icon="action.name" :label="action.label" :title="action.label" key="action.name"/>
                        </b-nav-item>
                    </b-nav>
                </b-col>
            </b-row>
            <b-row>
            <b-col v-if="paramSets.length === 0">
                
            </b-col>
            <b-col v-else-if="folderSetCount == 0">
                
            </b-col>
            <b-col v-else>
                <ecmfolder-select
                    v-model="$v.selectedSubSet"
                    :parameters="prtfldrs"
                    :selectedSet="selectedSubSet"
                    ref="folder_selector"
                    @reselected="reselectedfolder"/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <template v-if="loaded === false">
                    <div class="OTloading">
                        <div class="OTloader"></div>
                    </div>
                </template>
                <template v-else-if="loaded === true && folderSetCount == 0">
                   
                </template>
                <SettingsTable v-else
                    :rows="selectedSubParameters"
                    :columns="columns"
                    :customOptions="customOptionsPartitions"
                    :formcolumn="'2'"
                    @save="savePartitionFolder">
                    <template slot="table-header">
                        
                    </template>
                </SettingsTable>
            </b-col>
        </b-row>
        </template>
    </b-form>
</template>

<script>

import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { numericval } from '../../../utils/validatorECM.js';
import { showMessage } from '../../../utils/commonECM.js';
import OtifGlobalActions from '../../../../../../mtm-studio-components/src/components/table/GlobalActions.vue';
import SettingsTable from '@/ecm/components/ECMParametersTable.vue';
import EcmRepositoryConnections from '../../../../ecm/components/widgets/ECMRepositoryConnections.vue';
import ECMRepositoryFolders from '../../../../ecm/components/widgets/ECMRepositoryFolders.vue';
import ECMPartitionModal from '../../modals/ECMCreatePartition.vue';
import ECMCreatePartitionParameters from '../../modals/ECMCreatePartitionParameters.vue';
import ECMConfirmDialog from '../../modals/ECMCrawlerConfirmDlg.vue';
import { showConfirmationDialog } from '../../../utils/commonECM.js';
import StatusColumn from '../../links/ecmmandatorystatus.vue';
import { getguivalue } from '../../../utils/commonECM.js';

export default {

    props: ['realPartitionsConfigurations' , 'mandatoryPartitionsConfigurations', 'availablePartitionsConfigurations', 'realPartitionParametersConfigurations', 'mandatoryPartitionParametersConfigurations', 'availablePartitionParametersConfigurations'],
    
    components: {
        ECMErrorDialog,
        OtifGlobalActions,
        SettingsTable,
        ECMPartitionModal,
        ECMCreatePartitionParameters,
        'ecmconnection-select': EcmRepositoryConnections,
        'ecmfolder-select':ECMRepositoryFolders,
        ECMConfirmDialog,
    },
    mixins: [ validationMixin ],

    data() {
        return { 
            paramSets : [],//set of partitions
            selectedSet:'0',
            selectedName:'',
            selectedParameters:[],
            selectedFolders:[],

            selectedSubSet:'0',
            selectedSubName:'',
            
            fullPackage : [],
            fullParamsPackage:[],
            
            lastexistingindex:-1,
            selectedconfigparam:-1,
            loaded: false,
            messageDlg: false,
            confirmationDlg:false,
            showECMPartitionModal: false,
            showECMPartitionFoldersModal:false,
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            
            customOptions:  [],
            customOptionsPartitions:[            
            {
                'value': '0', 
                'text': 'Ready to crawl'
            },
            {
                'value': '1',
                'text': 'Suspended'
            }],
            globalActions: [{
                    name: 'add',
                    label: 'Add Partition',
                    callback: () => { this.addPartition(); }
                },
                {
                    name: 'delete',
                    label: 'Delete Partition',
                    callback: () => { this.deletePartition(); }
            }],
            partitionActions: [{
                    name: 'add',
                    label: 'Add Partition Folder',
                    callback: () => { this.addPartitionFolder(); }
                },
                {
                    name: 'delete',
                    label: 'Delete Partition Folder',
                    callback: () => { this.deletePartitionFolder(); }
            }],
            columns:[{
                name: 'name',
                label: 'Name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'status',
                label: '',
                sortable: false,
                editable:false,
                displayComponent:StatusColumn,
                
            },{
                name: 'value',
                label: 'Value',
                sortable: false,
                editable:true,
                render(row) {
                    if(row.guivalue)
                        return row.guivalue;
                    else
                    return row.value;
                }
            }],
            
        }
    },

    validations: {
        form: {
         
        }
    },
    computed: {

        prtfldrs(){
            var PartitionFolders = this.getPartitionFolders(this.selectedSet);
            if(PartitionFolders)
            {
                var setOfPartitionFolders = PartitionFolders.setOfPartitionFolders;
                if(setOfPartitionFolders)
                {
                    if(setOfPartitionFolders.length > 1)
                        return setOfPartitionFolders[1];
                }  
                 else{
                return [];
            }               
            }
            else{
                return [];
            } 
        },

        folderSetCount()
        {
            var PartitionFolders = this.getPartitionFolders(this.selectedSet);
            if(PartitionFolders)
            {
                var setOfPartitionFolders = PartitionFolders.setOfPartitionFolders;
                if(setOfPartitionFolders)
                {
                    if(setOfPartitionFolders.length > 1)
                        return setOfPartitionFolders[1].length;
                }
            }
            return 0;    
        },

        selectedSubParameters()
        {
            var PartitionFolders = this.getPartitionFolders(this.selectedSet);
            if(PartitionFolders)
            {
                var setOfPartitionFolders = PartitionFolders.setOfPartitionFolders;
                if(setOfPartitionFolders)
                {
                    if(setOfPartitionFolders.length > 1)
                    {
                        for (var cnt = 0; cnt < setOfPartitionFolders[1].length; cnt++)
                        {
                            const index  = setOfPartitionFolders[1][cnt].index;
                            if(index == this.selectedSubSet)
                            {
                                this.selectedSubName = setOfPartitionFolders[1][cnt].description;
                                return setOfPartitionFolders[1][cnt].setOfFolders;
                            }
                        }
                    }
                }
            }
            return []; 
        }
    },

    methods: {
        
        onGlobalAction(action) {
            if (action['callback']) {
                action.callback(action);
            }
        },

        folderSets()
        {
            this.selectedFolders = [];   
            var PartitionFolders = this.getPartitionFolders(this.selectedSet);
            if(PartitionFolders)
            {
                var setOfPartitionFolders = PartitionFolders.setOfPartitionFolders;
                if(setOfPartitionFolders)
                {
                    if(setOfPartitionFolders.length > 1)
                        this.selectedFolders = setOfPartitionFolders[1];
                }                
            } 
            if(this.$refs.folder_selector)
            {
                this.$refs.folder_selector.parameters = this.selectedFolders;
                this.$refs.folder_selector.refresh();
            } 
        },

        addPartition(){
            this.showECMPartitionModal = true;
        },

        createEcmPartition(conDescr){
            var that = this;
                        
            const len = that.paramSets.length;
            
            that.lastexistingindex++;
            
            var OneSet = [];
            var OneSetWithPartitionFolders=[];
            
            for (var cnt = 0; cnt < that.fullPackage.length; cnt++)
            {
                const name  = that.fullPackage[cnt].name;
                if(name != 'status' && name != 'statusDate')
                {
                    if(name == 'description')
                    {
                        that.realPartitionsConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": conDescr, "index": that.lastexistingindex});
                        OneSet.unshift({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : 1, "value": conDescr, "index": that.lastexistingindex });
                        OneSetWithPartitionFolders.unshift({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : 1, "value": conDescr, "index": that.lastexistingindex });
                    }
                    else
                    {
                        that.realPartitionsConfigurations.push({"name" : that.fullPackage[cnt].name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex});
                        OneSet.push({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex });
                        OneSetWithPartitionFolders.push({"name" : name, "type" : that.fullPackage[cnt].type, "defaultvalue": that.fullPackage[cnt].defaultvalue, "mandatory" : that.fullPackage[cnt].mandatory, "value": that.fullPackage[cnt].value, "index": that.lastexistingindex });
                    }
                }
            }
            
            var OneSetConfigParam = [];                 
            OneSetWithPartitionFolders.push(OneSetConfigParam);
            that.paramSets.push({"description":conDescr, "index":that.lastexistingindex, "setOfParameters":OneSet, "setOfPartitionFolders":OneSetWithPartitionFolders});
            
            if(that.paramSets.length > 0)
            {
                that.selectedSet=that.lastexistingindex;
                that.selectedSubSet=0;
                that.selectedSubName='';
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == that.lastexistingindex)
                    {
                        that.selectedName=that.paramSets[cnt].description;    
                        that.selectedParameters = that.paramSets[cnt].setOfParameters;
                        break;
                    }
                }
                if(that.$refs.params_selector)
                {
                    that.$refs.params_selector.selectedSet = that.selectedSet;
                    that.$refs.params_selector.refresh();
                }
            }
        },

        addPartitionFolder()
        {
            this.showECMPartitionFoldersModal = true;
        },

        getPartitionFolders(index)
        {
            var cnt = 0;
            for (cnt = 0; cnt < this.paramSets.length; cnt++)
            {
                if(this.paramSets[cnt].index == index)
                {
                    return this.paramSets[cnt];
                }
            }
            return null;
        },

        createEcmPartitionFolder(conDescr)
        {
            const PartitionFolders = this.getPartitionFolders(this.selectedSet);//this.paramSets[this.selectedSet];
            if(PartitionFolders)
            {
                const setOfPartitionFolders = PartitionFolders.setOfPartitionFolders;
                if(setOfPartitionFolders)
                {
                    const arraylen = setOfPartitionFolders[1].length;
                
                    var lastexistingindexpar = 0;
                
                    if(arraylen > 0)
                        lastexistingindexpar = Number(setOfPartitionFolders[1][arraylen - 1].index) + 1;

                    var OneSetConfigParam = [];
                    const descr = conDescr;
                    for (var cnt = 0; cnt < this.fullParamsPackage.length; cnt++)
                    {       
                        const defaultval = this.fullParamsPackage[cnt].value;         
                        if(this.fullParamsPackage[cnt].name == 'folderPathOrId')
                        {
                            this.realPartitionParametersConfigurations.push({"name" : this.fullParamsPackage[cnt].name, "type" : this.fullParamsPackage[cnt].type, "value": conDescr, "defaultvalue": this.fullParamsPackage[cnt].defaultvalue, "mandatory" : this.fullParamsPackage[cnt].mandatory, "index" :lastexistingindexpar, "parentindex" : setOfPartitionFolders[0].index});
                            OneSetConfigParam.push({"name" : this.fullParamsPackage[cnt].name, "type" : this.fullParamsPackage[cnt].type, "defaultvalue": this.fullParamsPackage[cnt].defaultvalue, "mandatory" : this.fullParamsPackage[cnt].mandatory, "value": conDescr, "index": lastexistingindexpar, "guivalue" : conDescr });

                        }
                        else{
                            if(this.fullParamsPackage[cnt].name == 'status')
                            {//for status it's mandatory field force to push some value
                                const itemguival = 'Ready to crawl';
                                this.realPartitionParametersConfigurations.push({"name" : this.fullParamsPackage[cnt].name, "type" : this.fullParamsPackage[cnt].type, "value": "0", "defaultvalue": this.fullParamsPackage[cnt].defaultvalue, "mandatory" : this.fullParamsPackage[cnt].mandatory, "index" :lastexistingindexpar, "parentindex" : setOfPartitionFolders[0].index});
                                OneSetConfigParam.push({"name" : this.fullParamsPackage[cnt].name, "type" : this.fullParamsPackage[cnt].type, "defaultvalue": this.fullParamsPackage[cnt].defaultvalue, "mandatory" : this.fullParamsPackage[cnt].mandatory, "value": itemguival, "index": lastexistingindexpar, "guivalue" : itemguival });
                            }
                            else
                            {
                                this.realPartitionParametersConfigurations.push({"name" : this.fullParamsPackage[cnt].name, "type" : this.fullParamsPackage[cnt].type, "value": this.fullParamsPackage[cnt].defaultvalue, "defaultvalue": this.fullParamsPackage[cnt].defaultvalue, "mandatory" : this.fullParamsPackage[cnt].mandatory, "index" :lastexistingindexpar, "parentindex" : setOfPartitionFolders[0].index});
                                OneSetConfigParam.push({"name" : this.fullParamsPackage[cnt].name, "type" : this.fullParamsPackage[cnt].type, "defaultvalue": this.fullParamsPackage[cnt].defaultvalue, "mandatory" : this.fullParamsPackage[cnt].mandatory, "value": defaultval, "index": lastexistingindexpar, "guivalue" : defaultval });
                            }
                        }
                    }

                    setOfPartitionFolders[1].push({"description":descr, "index":lastexistingindexpar, "setOfFolders":OneSetConfigParam});

                    this.selectedSubName=conDescr;   
                    this.selectedSubSet= lastexistingindexpar;
                    if(this.$refs.folder_selector)
                    {
                        this.$refs.folder_selector.selectedSet = this.selectedSubSet;
                        this.$refs.folder_selector.refresh();
                    }
                }
            }
            else{

            }
        },

        deletePartition(){
            var that = this;
            that.bDeletePartition = true;
            showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeletePartition, that.ecmResourceStrings.txtDeletePartition);
         },

        deletePartitionFolder()
        {
            var that = this;
            showConfirmationDialog(that, 'question', that.ecmResourceStrings.ttlDeletePartition, that.ecmResourceStrings.txtDeletePartition);
        },
        
        saveConfirmed()
        {         
            this.confirmationDlg = false;
            var that = this;
            if(that.bDeletePartition == true)
            {
                that.bDeletePartition = false;
                var itemX=that.selectedSet;
                var cnt = 0;
                for (cnt = 0; cnt < that.paramSets.length; cnt++)
                {
                    if(that.paramSets[cnt].index == itemX)
                    {
                        const removed = that.paramSets.splice(cnt, 1);
                        break;
                    }
                }

                if(itemX < that.paramSets.length)
                {
                    cnt = itemX;
                    for (cnt = itemX; cnt < that.paramSets.length; cnt++)
                    {
                        var newindex = that.paramSets[cnt].index - 1;
                        that.paramSets[cnt].index =newindex;
                        var dataSet = that.paramSets[cnt].setOfParameters;
                        if(dataSet)
                        {
                            var k = 0;
                            for (k = 0; k < dataSet.length; k++)
                            {
                                dataSet[k].index= newindex;
                            }
                        }
                        dataSet = that.paramSets[cnt].setOfPartitionFolders;
                        if(dataSet && dataSet.length > 0)
                        {
                            var mainelem = dataSet[0];
                            if(mainelem)
                            {
                                mainelem.index = newindex;
                            }
                        }
                    }
                }

                //remove all parameters configurations for this partition
                cnt = 0;   
                for (cnt = that.realPartitionParametersConfigurations.length -1; cnt > -1; cnt--)
                {
                    const index = that.realPartitionParametersConfigurations[cnt].parentindex;
                    if(index == itemX)   
                    {
                        const removed = that.realPartitionParametersConfigurations.splice(cnt, 1);
                    }
                }

                cnt = 0;   
                for (cnt = that.realPartitionParametersConfigurations.length -1; cnt > -1; cnt--)
                {
                    var parentindex = that.realPartitionParametersConfigurations[cnt].parentindex;
                    var newparentindex = that.realPartitionParametersConfigurations[cnt].parentindex - 1;
                    if(parentindex > itemX)   
                    {
                        that.realPartitionParametersConfigurations[cnt].parentindex = newparentindex;
                    }
                }

                //remove from real parameters
                cnt = 0;   
                for (cnt = that.realPartitionsConfigurations.length -1; cnt > -1; cnt--)
                {
                    const index = that.realPartitionsConfigurations[cnt].index;
                    if(index == itemX)   
                    {
                        const removed = that.realPartitionsConfigurations.splice(cnt, 1);
                    }
                }

                cnt = 0;   
                for (cnt = 0; cnt < that.realPartitionsConfigurations.length; cnt++)
                {
                    var originalindex = that.realPartitionsConfigurations[cnt].index;
                    if(originalindex > itemX)
                    {
                        const newpartindex = that.realPartitionsConfigurations[cnt].index - 1;
                        that.realPartitionsConfigurations[cnt].index = newpartindex;
                    }
                }
         
                if(that.paramSets.length > 0)
                {
                    that.selectedSet=that.paramSets[0].index;
                    that.selectedName=that.paramSets[0].description;
                    that.selectedParameters = that.paramSets[0].setOfParameters;
                    that.selectedSubSet=0;
                    if(that.paramSets[0].setOfPartitionFolders[1][0])
                        that.selectedSubName=that.paramSets[0].setOfPartitionFolders[1][0].description;
                    else
                        that.selectedSubName='';
                    that.folderSets();
                }
                else
                {
                    that.selectedSet=0;
                    that.selectedName='';
                    that.selectedParameters=[];
                    that.selectedSubSet=0;
                    that.selectedSubName='';
                }
                if(that.$refs.params_selector)
                {
                    that.$refs.params_selector.selectedSet = that.selectedSet;
                    that.$refs.params_selector.refresh();
                }
            }
            else
            {
                var parentX=that.selectedSet;
                var itemX=that.selectedSubSet;
                var PartitionFolders = this.getPartitionFolders(this.selectedSet);
                if(PartitionFolders)
                {
                    var setOfPartitionFolders = PartitionFolders.setOfPartitionFolders[1];
                    if(setOfPartitionFolders.length > 0)
                    {
                        var cnt = 0;
                        for (cnt = 0; cnt < setOfPartitionFolders.length; cnt++)
                        {
                            if(setOfPartitionFolders[cnt].index == itemX)
                            {
                                const removed = setOfPartitionFolders.splice(cnt, 1);
                                break;
                            }
                        }

                        if(itemX < setOfPartitionFolders.length)
                        {
                            cnt = itemX;
                            for (cnt = itemX; cnt < setOfPartitionFolders.length; cnt++)
                            {
                                var newindex = setOfPartitionFolders[cnt].index - 1;
                                setOfPartitionFolders[cnt].index =newindex;
                                var dataSet = setOfPartitionFolders[cnt].setOfFolders;
                                if(dataSet)
                                {
                                    var k = 0;
                                    for (k = 0; k < dataSet.length; k++)
                                    {
                                        dataSet[k].index= newindex;
                                    }
                                }
                            }
                        }

                        //remove from real parameters
                        cnt = 0;   
                        for (cnt = that.realPartitionParametersConfigurations.length -1; cnt > -1; cnt--)
                        {
                            var indexParent = that.realPartitionParametersConfigurations[cnt].parentindex;
                            if(indexParent == parentX)
                            {
                                var index = that.realPartitionParametersConfigurations[cnt].index;
                                if(index == itemX)   
                                {
                                    const removed = that.realPartitionParametersConfigurations.splice(cnt, 1);
                                }
                            }
                        }

                        if(itemX < setOfPartitionFolders.length)
                        {
                            for (cnt = 0; cnt < that.realPartitionParametersConfigurations.length; cnt++)
                            {
                                var indexParent = that.realPartitionParametersConfigurations[cnt].parentindex;
                                if(indexParent == parentX)
                                {
                                    var currentIndex = that.realPartitionParametersConfigurations[cnt].index;
                                    if(itemX < currentIndex)
                                    {
                                        var newindex = that.realPartitionParametersConfigurations[cnt].index - 1;
                                     that.realPartitionParametersConfigurations[cnt].index = newindex;
                                    }
                                }
                            }
                        }
                        
                        that.updateComboBoxPartitionFolders();
                    }
                }
            }
        },

        updateComboBoxPartitionFolders()
        {
            var that = this;
            var PartitionFolders = this.getPartitionFolders(this.selectedSet);
            if(PartitionFolders)
            {
                var setOfPartitionFolders = PartitionFolders.setOfPartitionFolders[1];
                if(setOfPartitionFolders.length > 0)
                {
                    that.selectedSubSet=setOfPartitionFolders[0].index;
                    that.selectedSubName=setOfPartitionFolders[0].description;
                    if(that.$refs.folder_selector)
                    {
                         that.$refs.folder_selector.selectedSet = that.selectedSubSet;
                        that.$refs.folder_selector.refresh();  
                    }
                    else
                    {
                        that.selectedSubSet=0;
                        that.selectedSubName='';
                    }
                }
            }
        },

        reselected(value) {
           var that = this;
           that.selectedSet=value;
           var cnt = 0;
           for (cnt = 0; cnt < that.paramSets.length; cnt++)
            {
                if(that.paramSets[cnt].index == value)
                {
                    that.selectedName=that.paramSets[cnt].description;    
                    that.selectedParameters = that.paramSets[cnt].setOfParameters;
                    const setOfPartitionFolders = that.paramSets[cnt].setOfPartitionFolders;
                    if(setOfPartitionFolders[1] && setOfPartitionFolders[1].length > 0)
                    {
                        if(that.selectedSubSet=setOfPartitionFolders[1][0])
                        {
                            that.selectedSubSet=setOfPartitionFolders[1][0].index;
                            that.selectedSubName=setOfPartitionFolders[1][0].description;
                            that.folderSets();
                        }
                    }
                    else
                    {
                        that.selectedSubSet=0;
                        that.selectedSubName='';
                    }
                    return;
                }
            }
        },

        reselectedfolder(value){
            this.selectedSubSet=value;
            const PartitionFolders = this.getPartitionFolders(this.selectedSet);
            if(PartitionFolders)
            {
                const setOfPartitionFolders = PartitionFolders.setOfPartitionFolders;
                if(setOfPartitionFolders.length > 1 && setOfPartitionFolders[1].length > 0)
                {
                    for (var cnt = 0; cnt < setOfPartitionFolders[1].length; cnt++)
                    {
                        if(setOfPartitionFolders[1][cnt])
                        {
                            const index  = setOfPartitionFolders[1][cnt].index;
                            if(index == this.selectedSubSet)
                            {
                                this.selectedSubName = setOfPartitionFolders[1][cnt].description;
                                
                                return;
                            }
                        }
                    }
                }
            }
        },

        save(element) {
            //prevent old name just in case if for mandatory field value is empty 
            var that = this;
            var originalvalue='';
            const result = this.realPartitionsConfigurations.filter((el) => (el.name == element.name && el.index == element.index));
            if (result != undefined && result.length == 0)
            {
                //not found
            }
            else if (result != undefined && result.length == 1)
            {
                originalvalue = result[0].value;
            }

            const value = element.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,""); 
            }
            else if(element.mandatory == 1/* && element.name == 'description'*/)
            {
                //can not be empty
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtErrorMandatory);
                element.value = originalvalue;
                return;
            }
            if (result[0])
            {
                //should be here
                result[0].value = element.value;
                //change description of package in set
                if(element.name == 'description')
                {
                    var cnt = 0;
                    for (cnt = 0; cnt < that.paramSets.length; cnt++)
                    {
                        if(that.paramSets[cnt].description == originalvalue)
                        {
                            that.paramSets[cnt].description = element.value; 
                            that.selectedName=that.paramSets[cnt].description;  
                            if(that.$refs.params_selector)
                                that.$refs.params_selector.refresh();
                            break;
                        }
                    }
                }
            }
        },

        savePartitionFolder(element)
        {
            var that = this;
            var originalvalue='';
            const result = this.realPartitionParametersConfigurations.filter((el) => (el.name == element.name && el.index == element.index && el.parentindex == this.selectedSet));
            if (result != undefined && result.length == 0)
            {
                //not found
            }
            else if (result != undefined && result.length == 1)
            {
                originalvalue = result[0].value;
            }

            const value = element.value;
            var configvalue = "";
            if(value.trim().length > 0)
            {
                configvalue = JSON.stringify(value); 
                //configvalue = configvalue.replace(/"/g, ""); 
                configvalue = configvalue.replace(/"/ , ""); 
                configvalue = configvalue.replace(/"$/,"");
            }
            else if(element.mandatory == 1/* && element.name == 'description'*/)
            {
                //can not be empty
                this.$snotify.clear();
                this.$snotify.error(this.ecmResourceStrings.txtErrorMandatory);
                element.value = originalvalue;
                return;
            }
            if (result[0])
            {
                //change description of package in set
                if(element.name == 'folderPathOrId')
                {
                    result[0].value = element.value;
                    const PartitionFolders = this.getPartitionFolders(this.selectedSet);
                    if(PartitionFolders)
                    {
                        const setOfPartitionFolders = PartitionFolders.setOfPartitionFolders[1];
                        if(setOfPartitionFolders)
                        {
                            var cnt = 0;
                            for (cnt = 0; cnt < setOfPartitionFolders.length; cnt++)
                            {
                                if(setOfPartitionFolders[cnt].description == originalvalue)
                                {
                                    setOfPartitionFolders[cnt].description = element.value; 
                                    this.selectedSubName=setOfPartitionFolders[cnt].description;  
                                    if(this.$refs.folder_selector)
                                        this.$refs.folder_selector.refresh();
                                    break;
                                }
                            }
                        }
                    }
                }
                else
                {
                    if(element.name == 'status')
                    {
                        if(element.value == 'Suspended')
                        {
                            result[0].value = "1";
                        }
                        else
                        {
                            result[0].value = "0";
                        }
                    }
                    else
                    {
                        result[0].value = element.value;
                    }

                    //update UI working collections
                    const PartitionFolders = this.getPartitionFolders(this.selectedSet);
                    if(PartitionFolders)
                    {
                        const setOfPartitionFolders = PartitionFolders.setOfPartitionFolders[1];
                        if(setOfPartitionFolders)
                        {
                            var cnt = 0;
                            for (cnt = 0; cnt < setOfPartitionFolders.length; cnt++)
                            {
                                if(setOfPartitionFolders[cnt].index == that.selectedSubSet)
                                {
                                    const workingset = setOfPartitionFolders[cnt].setOfFolders; 
                                        
                                    if(workingset)
                                    {
                                        var resultData = workingset.filter((el) => (el.name == element.name));
                                                   
                                        if (resultData != undefined &&resultData.length == 1)
                                        {
                                            resultData[0].value= element.value;
                                            resultData[0].guivalue = element.value;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
    
        getlastindex:function(setOfPartitionFolders)
        {
            var cnt = 0;
            var index = -1;
            if(setOfPartitionFolders)
            {
                for (cnt = 0; cnt < setOfPartitionFolders.length; cnt++)
                {
                    const entryValue = setOfPartitionFolders[cnt];
                    if (entryValue)
                    {
                        const curindex = entryValue.index;
                        if(Number(curindex) > Number(index))
                        {
                            index = curindex;
                        }
                    }
                }
            }
            return index;
        },

        initParams : function()
        {   
            //  fullParamsPackage
            var that = this;
            that.fullPackage = [];//all mandatory + available together - one whole set (prototype of set) 
            that.paramSets = [];
            that.fullParamsPackage = [];
            var cnt = 0;
            for (cnt = 0; cnt < that.mandatoryPartitionParametersConfigurations.length; cnt++)
            {
                that.fullParamsPackage.push({"name" : that.mandatoryPartitionParametersConfigurations[cnt].name, "type" : that.mandatoryPartitionParametersConfigurations[cnt].type, "defaultvalue": that.mandatoryPartitionParametersConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.mandatoryPartitionParametersConfigurations[cnt].defaultvalue});
            }
            cnt = 0;
            for (cnt = 0; cnt < that.availablePartitionParametersConfigurations.length; cnt++)
            {
                that.fullParamsPackage.push({"name" : that.availablePartitionParametersConfigurations[cnt].name, "type" : that.availablePartitionParametersConfigurations[cnt].type, "defaultvalue": that.availablePartitionParametersConfigurations[cnt].defaultvalue, "mandatory" : 0, "value": that.availablePartitionParametersConfigurations[cnt].value});
            }
            cnt = 0;
            for (cnt = 0; cnt < that.mandatoryPartitionsConfigurations.length; cnt++)
            {
                that.fullPackage.push({"name" : that.mandatoryPartitionsConfigurations[cnt].name, "type" : that.mandatoryPartitionsConfigurations[cnt].type, "defaultvalue": that.mandatoryPartitionsConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.mandatoryPartitionsConfigurations[cnt].defaultvalue});
            }
            cnt = 0;
            for (cnt = 0; cnt < that.availablePartitionsConfigurations.length; cnt++)
            {
                that.fullPackage.push({"name" : that.availablePartitionsConfigurations[cnt].name, "type" : that.availablePartitionsConfigurations[cnt].type, "defaultvalue": that.availablePartitionsConfigurations[cnt].defaultvalue, "mandatory" : 0, "value": that.availablePartitionsConfigurations[cnt].value});
            }
    
            var startindex = -1;
            var lastindex = -1;
            var OneSet = [];
            var OneSetWithPartitionFolders=[];
            var descr = ''; var index = -1;
            cnt = 0;
            for (cnt = 0; cnt < that.realPartitionsConfigurations.length; cnt++)
            {
                const name  = that.realPartitionsConfigurations[cnt].name;
                if(startindex == -1)
                {
                    startindex = 0;
                }
                lastindex = that.realPartitionsConfigurations[cnt].index;
                var guivalue = that.realPartitionsConfigurations[cnt].value;
                
                if(name == 'status')
                {
                    guivalue = getguivalue('partitionstatus', that.realPartitionsConfigurations[cnt].value);
                }
                if(that.realPartitionsConfigurations[cnt].index == startindex)
                {
                    if(name != 'status' && name != 'statusDate')
                    {
                        if(name == 'description')
                        {
                            descr = that.realPartitionsConfigurations[cnt].value;
                            index = that.realPartitionsConfigurations[cnt].index;
                            OneSet.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                            OneSetWithPartitionFolders.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                        }
                        else
                        {
                            OneSet.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionsConfigurations[cnt].mandatory, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                            OneSetWithPartitionFolders.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionsConfigurations[cnt].mandatory, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                        }
                    }       
                }
                else
                {
                    if(name != 'status' && name != 'statusDate')
                    {
                        //index was changed
                        var OneSetConfigParam = [];
                                    
                        OneSetWithPartitionFolders.push(OneSetConfigParam);
                        that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet, "setOfPartitionFolders":OneSetWithPartitionFolders});
                
                        startindex = that.realPartitionsConfigurations[cnt].index;
                    
                        OneSet = []; OneSetWithPartitionFolders=[];
                    
                        if(name == 'description')
                        {
                            descr = that.realPartitionsConfigurations[cnt].value;
                            index = that.realPartitionsConfigurations[cnt].index;
                            OneSet.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                            OneSetWithPartitionFolders.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : 1, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                        }
                        else
                        {
                            OneSet.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionsConfigurations[cnt].mandatory, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                            OneSetWithPartitionFolders.push({"name" : that.realPartitionsConfigurations[cnt].name, "type" : that.realPartitionsConfigurations[cnt].type, "defaultvalue": that.realPartitionsConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionsConfigurations[cnt].mandatory, "value": that.realPartitionsConfigurations[cnt].value, "index": that.realPartitionsConfigurations[cnt].index, "guivalue" : guivalue});
                        }
                    }
                }
            }
            
            if(lastindex != -1 && lastindex == startindex) //the last one
            {
                var OneSetConfigParam = [];
                OneSetWithPartitionFolders.push(OneSetConfigParam);
                that.paramSets.push({"description":descr, "index":index, "setOfParameters":OneSet, "setOfPartitionFolders":OneSetWithPartitionFolders});
            }
            if(that.paramSets.length > 0)
            {
                that.selectedSet=0;
                that.selectedName=that.paramSets[0].description;
                that.selectedParameters = that.paramSets[0].setOfParameters;
            }
            //now fill all with Configuration parameters
            cnt = 0;
            if(that.realPartitionParametersConfigurations)
            {
                for (cnt = 0; cnt < that.realPartitionParametersConfigurations.length; cnt++)
                {
                    const item = that.realPartitionParametersConfigurations[cnt];
                    
                    const itemname = that.realPartitionParametersConfigurations[cnt].name;
                    
                    var itemvalue = that.realPartitionParametersConfigurations[cnt].value;
                    
                    var itemguivalue = itemvalue;
                    
                    if(itemname == 'status')
                    {
                        if(itemvalue == "0")
                        {
                            itemguivalue = 'Ready to crawl';
                            itemvalue = 'Ready to crawl';
                        }
                        if(itemvalue == "1")
                        {
                            itemguivalue = 'Suspended';
                            itemvalue = 'Suspended';
                        }
                    }
                    const parentindex = item.parentindex;
                    const onecurindex = item.index;
                    //find tha data with this index in configSet
                    //here all arrays are empty
                    for (var i = 0; i < that.paramSets.length;  i++)
                    {
                        const OneParamSet = that.paramSets[i];
                        if(OneParamSet.index == parentindex)
                        {
                            const collectionSet = OneParamSet.setOfPartitionFolders;
                            const index = collectionSet[0].index;
                            if(index == parentindex)
                            {
                                var workingArray = collectionSet[collectionSet.length - 1];
                                var result = workingArray.filter((el) => (el.index == onecurindex));
                                if(result != undefined && result.length == 0)
                                {
                                    //not found
                                    var OneSetConfigParam = [];
                                    var descr = 'temp';
                                    if(itemname == 'folderPathOrId')
                                    {
                                        descr=itemvalue;
                                    }
                                    OneSetConfigParam.push({"name" : that.realPartitionParametersConfigurations[cnt].name, "type" : that.realPartitionParametersConfigurations[cnt].type, "defaultvalue": that.realPartitionParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionParametersConfigurations[cnt].mandatory, "value": that.realPartitionParametersConfigurations[cnt].value, "index": that.realPartitionParametersConfigurations[cnt].index, "guivalue" : itemguivalue});
                                    workingArray.push({"description":descr, "index":onecurindex, "setOfFolders":OneSetConfigParam});
                                    break;
                                }
                                else if(result != undefined && result.length == 1)
                                {
                                    if(that.realPartitionParametersConfigurations[cnt].name == 'status')
                                    {
                                        result[0].setOfFolders.push({"name" : that.realPartitionParametersConfigurations[cnt].name, "type" : that.realPartitionParametersConfigurations[cnt].type, "defaultvalue": that.realPartitionParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionParametersConfigurations[cnt].mandatory, "value": itemguivalue, "index": that.realPartitionParametersConfigurations[cnt].index, "guivalue" : itemguivalue});
                                    }
                                    else
                                    {
                                        result[0].setOfFolders.push({"name" : that.realPartitionParametersConfigurations[cnt].name, "type" : that.realPartitionParametersConfigurations[cnt].type, "defaultvalue": that.realPartitionParametersConfigurations[cnt].defaultvalue, "mandatory" : that.realPartitionParametersConfigurations[cnt].mandatory, "value": that.realPartitionParametersConfigurations[cnt].value, "index": that.realPartitionParametersConfigurations[cnt].index, "guivalue" : itemguivalue});
                                    }
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            that.lastexistingindex = lastindex;
            that.folderSets();
        },
    },
      
    mounted() {

            var breadcrumbs = [{
                name: 'settings',
                meta: { label: 'Settings' }
            },        {
                name: 'ecm-repositories',
                meta: { label: 'Repositories' }
            },{
                name: 'ecm-repo',
                meta: { label: 'Update ECM Repository' }
            }];
            this.$store.commit('breadcrumbs', breadcrumbs);
    },

    created() {
        var that = this;
        that.initParams();
        that.loaded = true;
    },
}
</script>